/**
 * Lightweight author registry.
 *
 * Posts keep a simple `author` string (e.g. "MediaLabs Engineering"); we resolve
 * that to a rich profile here so both the catalog cards and the article page can
 * render a proper author card (name, role, bio, avatar) without changing the
 * blog data schema.
 *
 * `avatar` may be an image URL. When it is null, <AuthorAvatar /> renders the
 * branded MediaLabs mark instead of a stock photo (honest for a team byline).
 */
export const AUTHORS = {
  'MediaLabs Engineering': {
    name: 'MediaLabs Engineering',
    role: 'Engineering & Product Team',
    bio: 'The engineering and strategy team at MediaLabs — shipping enterprise-grade web and mobile products for founders and C-suite leaders across Southeast Asia. We write about what we learn building fast, scalable software.',
    avatar: null,
  },
};

const DEFAULT_AUTHOR = {
  name: 'MediaLabs Team',
  role: 'Contributor',
  bio: 'Insights from the MediaLabs team on building fast, scalable software.',
  avatar: null,
};

export function getAuthor(name) {
  if (name && AUTHORS[name]) return AUTHORS[name];
  return { ...DEFAULT_AUTHOR, name: name || DEFAULT_AUTHOR.name };
}
